import { Navigate, Outlet } from 'react-router-dom'

import { paths } from '@/app/router/paths'
import { useAuth } from '@/features/auth/authContext'

interface AreaRouteProps {
  area: 'tenant' | 'platform'
}

/**
 * Sits under `ProtectedRoute`, so the session is already known. A platform
 * session (no Standort) is sent to its own area from any tenant page, and a
 * tenant session away from the platform's: each side's endpoints refuse the
 * other with a 403, so the screen would be nothing but errors.
 */
export function AreaRoute({ area }: AreaRouteProps) {
  const { isPlatform } = useAuth()

  if (isPlatform !== (area === 'platform')) {
    return <Navigate to={isPlatform ? paths.admin : paths.pipeline} replace />
  }

  return <Outlet />
}
